import { render } from "./projectsSlide3.vue?vue&type=template&id=5f190d50&scoped=true"
import script from "./projectsSlide3.vue?vue&type=script&lang=js"
export * from "./projectsSlide3.vue?vue&type=script&lang=js"

import "./projectsSlide3.vue?vue&type=style&index=0&id=5f190d50&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f190d50"]])

export default __exports__